import React from 'react';
import './improvements.css';
import Header from "../../components/Header/Header";

const Improvements = () => {
    return (
        <>
            <Header/>
            <div className="page">
                <div className="improvements__items">
                    <div className="improvements__item">
                        <div className="improvements__text">На странице «Статистика» добавлена таблица проданных абонементов с указанным тренером</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлен фильтр посетителей по дате последней тренировки</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность открыть карточку клиента в отдельной вкладке (страницы: абонементы, тренировки и продажи)</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность отредактировать почту посетителя.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность перехода в Telegram и WhatsApp чат с посетителем из карточки клиента.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность установки произвольного периода для таблицы лидеров.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность открыть карточку клиента из списка записей группового занятия при нажатии на колесо мыши.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность установки контроля пропусков занятий.</div>
                        <div className="improvements__hint">При использовании этой опции каждое посещение нужно отметить специальным маркером. Если количество неявок на занятие превысит лимит, запись будет заблокирована.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность скрыть групповое занятие из мобильного приложения и виджета.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность удаления связанных с платежом абонементов и тренировок, а также возврата товаров при удалении платежа.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность смены даты продажи абонемента при его добавлении.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность фильтровать тренировки по количеству занятий и ограничениям, указанным в абонементе.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность получить список новых посетителей.</div>
                        <div className="improvements__hint">Фильтр доступен на странице «Посетители». При применении фильтра будут отображены пользователи, не посетившие ни одной тренировки.</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">Добавлена возможность получить список должников.</div>
                        <div className="improvements__hint">Для отображения списка выберите фильтр «Должники» на странице «Посетители».</div>
                    </div>
                    <div className="improvements__item">
                        <div className="improvements__text">При расчёте зарплат теперь можно учитывать стоимость абонемента.</div>
                        <div className="improvements__hint">Стоимость тренировки будет рассчитана как стоимость абонемента, делённая на количество тренировок.</div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Improvements;